import { render, staticRenderFns } from "./admin-database-setup-layout.component.vue?vue&type=template&id=cb3592e0"
import script from "./admin-database-setup-layout.component.ts?vue&type=script&lang=ts&external"
export * from "./admin-database-setup-layout.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports